import { render, staticRenderFns } from "./delivery_to_device.vue?vue&type=template&id=22b1c355&scoped=true&"
import script from "./delivery_to_device.vue?vue&type=script&lang=js&"
export * from "./delivery_to_device.vue?vue&type=script&lang=js&"
import style0 from "./delivery_to_device.vue?vue&type=style&index=0&id=22b1c355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1c355",
  null
  
)

export default component.exports